export default __webpack_public_path__ + "static/media/SOURCE THERMALE.f3e05a6e.svg";